import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const digits = (v) => (typeof v === "number" ? String(Math.round(v)) : String(v ?? "").replace(/\D/g, ""));
const fmt = (v) => { const d = digits(v); return d ? Number(d).toLocaleString("id-ID") : ""; };

// Accepts "30.000" or "30000"; emits digits-only value via onChange({ target: { value } }).
export function RupiahInput({ value, onChange, onBlur, ...props }) {
  const [text, setText] = useState(fmt(value));
  const [focus, setFocus] = useState(false);
  useEffect(() => { if (!focus) setText(fmt(value)); }, [value, focus]);
  return (
    <Input
      {...props}
      type="text"
      inputMode="numeric"
      value={text}
      onFocus={() => setFocus(true)}
      onChange={(e) => {
        const t = e.target.value.replace(/[^\d.]/g, "");
        setText(t);
        onChange?.({ target: { value: t.replace(/\D/g, "") } });
      }}
      onBlur={(e) => { setFocus(false); setText(fmt(text)); onBlur?.(e); }}
    />
  );
}
